export const VERSION = 'VERSION';
export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS';
export const LOG_OUT = 'LOG_OUT';
export const KEEP_SESSION = 'KEEP_SESSION';
export const LOAD_BASIC_INFO_SECURITY = 'LOAD_BASIC_INFO_SECURITY';
export const LOAD_SESSION_USER_SUCCESS = 'LOAD_SESSION_USER_SUCCESS';
export const SESSION_USER_IS_LOADING = 'SESSION_USER_IS_LOADING';
export const SESSION_USER_HAS_ERROR = 'SESSION_USER_HAS_ERROR';
export const TUTORIAL = 'TUTORIAL';

export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const USERS_SUCCESS = 'USERS_SUCCESS';
export const USER_HAS_ERROR = 'USER_HAS_ERROR';
export const USERS_IS_LOADING = 'USERS_IS_LOADING';
export const USERS_IS_SAVING = 'USERS_IS_SAVING';

export const LOAD_PROVIDER_SUCCESS = 'LOAD_PROVIDER_SUCCESS';
export const PROVIDERS_SUCCESS = 'PROVIDERS_SUCCESS';
export const PROVIDER_HAS_ERROR = 'PROVIDER_HAS_ERROR';
export const PROVIDERS_IS_LOADING = 'PROVIDERS_IS_LOADING';
export const PROVIDERS_IS_SAVING = 'PROVIDERS_IS_SAVING';

export const LOAD_REFERENCE_SUCCESS = 'LOAD_REFERENCE_SUCCESS';
export const REFERENCES_SUCCESS = 'REFERENCES_SUCCESS';
export const REFERENCE_HAS_ERROR = 'REFERENCE_HAS_ERROR';
export const REFERENCES_IS_LOADING = 'REFERENCES_IS_LOADING';
export const REFERENCES_IS_SAVING = 'REFERENCES_IS_SAVING';

export const LOAD_TEMPLATES_SUCCESS = 'LOAD_TEMPLATES_SUCCESS';
export const TEMPLATE_SUCCESS = 'TEMPLATE_SUCCESS';
export const TEMPLATE_HAS_ERROR = 'TEMPLATE_HAS_ERROR';
export const TEMPLATES_IS_LOADING = 'TEMPLATES_IS_LOADING';
export const TEMPLATE_IS_SAVING = 'TEMPLATE_IS_SAVING';

export const XEF_SUCCESS = 'XEF_SUCCESS';
export const XEF_HAS_ERROR = 'XEF_HAS_ERROR';
export const XEF_IS_LOADING = 'XEF_IS_LOADING';
export const XEF_IS_SAVING = 'XEF_IS_SAVING';
export const XEF_TIME_REFERENCE = 'XEF_TIME_REFERENCE';
export const XEF_ADD_EVENTS = 'XEF_ADD_EVENTS';
export const XEF_SET_LOCAL = 'XEF_SET_LOCAL';

export const LOAD_MACHINE_SUCCESS = 'LOAD_MACHINE_SUCCESS';
export const MACHINES_SUCCESS = 'MACHINES_SUCCESS';
export const MACHINES_HAS_ERROR = 'MACHINES_HAS_ERROR';
export const MACHINES_IS_LOADING = 'MACHINES_IS_LOADING';
export const MACHINES_IS_SAVING = 'MACHINES_IS_SAVING';

export const LOAD_TYPE_MACHINE_SUCCESS = 'LOAD_TYPE_MACHINE_SUCCESS';
export const TYPE_MACHINES_SUCCESS = 'TYPE_MACHINES_SUCCESS';
export const TYPE_MACHINES_HAS_ERROR = 'TYPE_MACHINES_HAS_ERROR';
export const TYPE_MACHINES_IS_LOADING = 'TYPE_MACHINES_IS_LOADING';
export const TYPE_MACHINES_IS_SAVING = 'TYPE_MACHINES_IS_SAVING';

export const LOAD_LOCAL_SUCCESS = 'LOAD_LOCAL_SUCCESS';
export const LOCALS_SUCCESS = 'LOCALS_SUCCESS';
export const LOCALS_HAS_ERROR = 'LOCALS_HAS_ERROR';
export const LOCALS_IS_LOADING = 'LOCALS_IS_LOADING';
export const LOCALS_IS_SAVING = 'LOCALS_IS_SAVING';
export const LOAD_LOCAL_INFO_SUCCESS = 'LOAD_LOCAL_INFO_SUCCESS';
export const LOCALS_INFO_SUCCESS = 'LOCALS_INFO_SUCCESS';

export const LOAD_PRODUCT_SUCCESS = 'LOAD_PRODUCT_SUCCESS';
export const PRODUCTS_SUCCESS = 'PRODUCTS_SUCCESS';
export const PRODUCTS_HAS_ERROR = 'PRODUCTS_HAS_ERROR';
export const PRODUCTS_IS_LOADING = 'PRODUCTS_IS_LOADING';
export const PRODUCTS_IS_SAVING = 'PRODUCTS_IS_SAVING';
export const LOAD_WORKSTATION_SUCCESS = 'LOAD_WORKSTATION_SUCCESS';

export const LOAD_FORECAST_SUCCESS = 'LOAD_FORECAST_SUCCESS';
export const FORECASTS_SUCCESS = 'FORECASTS_SUCCESS';
export const FORECASTS_HAS_ERROR = 'FORECASTS_HAS_ERROR';
export const FORECASTS_IS_LOADING = 'FORECASTS_IS_LOADING';
export const FORECASTS_IS_SAVING = 'FORECASTS_IS_SAVING';

export const LOAD_DISPLAY_SUCCESS = 'LOAD_DISPLAY_SUCCESS';
export const DISPLAYS_SUCCESS = 'DISPLAYS_SUCCESS';
export const DISPLAYS_HAS_ERROR = 'DISPLAYS_HAS_ERROR';
export const DISPLAYS_IS_LOADING = 'DISPLAYS_IS_LOADING';
export const DISPLAYS_IS_SAVING = 'DISPLAYS_IS_SAVING';

export const LOAD_LIST_SUCCESS = 'LOAD_LIST_SUCCESS';
export const LISTS_HAS_ERROR = 'LISTS_HAS_ERROR';
export const LISTS_IS_LOADING = 'LISTS_IS_LOADING';
export const LISTS_IS_SAVING = 'LISTS_IS_SAVING';

export const LOAD_TERMOMETRE_SUCCESS = 'LOAD_TERMOMETRE_SUCCESS';
export const TERMOMETRES_SUCCESS = 'DISPLAYS_SUCCESS';
export const TERMOMETRES_HAS_ERROR = 'DISPLAYS_HAS_ERROR';
export const TERMOMETRES_IS_LOADING = 'DISPLAYS_IS_LOADING';
export const TERMOMETRES_IS_SAVING = 'DISPLAYS_IS_SAVING';
export const LOAD_TERMOMETRE_FIELDS_SUCCESS = 'LOAD_TERMOMETRE_FIELDS_SUCCESS';

export const LOAD_CLIENT_SUCCESS = 'LOAD_CLIENT_SUCCESS';
export const LOAD_CLIENTS_SUCCESS = 'LOAD_CLIENTS_SUCCESS';
export const CLIENT_HAS_ERROR = 'CLIENT_HAS_ERROR';
export const CLIENTS_IS_LOADING = 'CLIENTS_IS_LOADING';
export const CLIENTS_IS_SAVING = 'CLIENTS_IS_SAVING';

export const INSTANCE_HAS_ERROR = 'INSTANCE_HAS_ERRORED';
export const INSTANCE_IS_LOADING = 'INSTANCE_IS_LOADING';
export const INSTANCE_FETCH_DATA = 'INSTANCE_FETCH_DATA_SUCCESS';
export const INSTANCES_FETCH_DATA = 'INSTANCES_FETCH_DATA';
export const INSTANCE_HANDLE_CHANGE = 'INSTANCE_HANDLE_CHANGE';
export const CLEAR_INSTANCE_VALUES = 'CLEAR_INSTANCE_VALUES';
export const SAVING_INSTANCE_CHANGES = 'SAVING_INSTANCE_CHANGES';
export const SAVE_INSTANCE_ERROR = 'SAVE_INSTANCE_ERROR';
export const EXECUTE_INSTANCE_TRANSITION = 'EXECUTE_INSTANCE_TRANSITION';
export const EXECUTING_INSTANCE_TRANSITION = 'EXECUTING_INSTANCE_TRANSITION';

export const PROCESS_HAS_ERROR = 'PROCESS_HAS_ERRORED';
export const PROCESS_IS_LOADING = 'PROCESS_IS_LOADING';
export const PROCESS_FETCH_DATA = 'PROCESS_FETCH_DATA_SUCCESS';
export const PROCESS_MESSAGES = 'PROCESS_MESSAGES';
export const SET_PARAMETERS_LOAD = 'SET_PARAMETERS_LOAD';
export const INSTANCE_OPENED_FETCH_DATA = 'INSTANCE_OPENED_FETCH_DATA';

export const MANUAl_PROCESS_HAS_ERROR = 'MANUAl_PROCESS_HAS_ERRORED';
export const MANUAl_PROCESS_IS_LOADING = 'MANUAl_PROCESS_IS_LOADING';
export const MANUAl_PROCESS_FETCH_DATA = 'MANUAl_PROCESS_FETCH_DATA_SUCCESS';

export const MANAGE_PROCESS_HAS_ERROR = 'MANAGE_PROCESS_HAS_ERRORED';
export const MANAGE_PROCESS_IS_LOADING = 'MANAGE_PROCESS_IS_LOADING';
export const MANAGE_PROCESS_IS_SAVING = 'MANAGE_PROCESS_IS_SAVING';
export const MANAGE_PROCESS_FETCH_DATA = 'MANAGE_PROCESS_FETCH_DATA_SUCCESS';
export const MANAGE_PROCESS_ADD_FAMILY = 'MANAGE_PROCESS_ADD_FAMILY';
export const MANAGE_PROCESS_EDIT_FAMILY = 'MANAGE_PROCESS_EDIT_FAMILY';
export const MANAGE_PROCESS_DUPLICATE_FAMILY = 'MANAGE_PROCESS_DUPLICATE_FAMILY';
export const MANAGE_PROCESS_DELETE_FAMILY = 'MANAGE_PROCESS_DELETE_FAMILY';
export const MANAGE_PROCESS_ADD_PROCESS = 'MANAGE_PROCESS_ADD_PROCESS';
export const MANAGE_PROCESS_EDIT_PROCESS = 'MANAGE_PROCESS_EDIT_PROCESS';
export const MANAGE_PROCESS_DUPLICATE_PROCESS = 'MANAGE_PROCESS_DUPLICATE_PROCESS';
export const MANAGE_PROCESS_DELETE_PROCESS = 'MANAGE_PROCESS_DELETE_PROCESS';

export const MANAGE_FORM_HAS_ERROR = 'MANAGE_FORM_HAS_ERROR';
export const MANAGE_FORM_IS_LOADING = 'MANAGE_FORM_IS_LOADING';
export const MANAGE_FORM_IS_SAVING = 'MANAGE_FORM_IS_SAVING';
export const MANAGE_FORM_FETCH_DATA = 'MANAGE_FORM_FETCH_DATA';

export const CATALOG_HAS_ERROR = 'CATALOG_HAS_ERRORED';
export const CATALOG_IS_LOADING = 'CATALOG_IS_LOADING';
export const CATALOG_IS_SAVING = 'CATALOG_IS_SAVING';
export const CATALOG_FETCH_DATA = 'CATALOG_FETCH_DATA_SUCCESS';
export const CATALOGS_FETCH_DATA_SUCCESS = 'CATALOGS_FETCH_DATA_SUCCESS';

export const XHEF_LOAD_SUCCESS = 'XHEF_LOAD_SUCCESS';

export const SET_LANG = 'SET_LANG';
export const SET_APP_BAR = 'SET_APP_BAR';
export const SET_WINDOW = 'SET_WINDOW';
export const SET_TOOLS = 'SET_TOOLS';
export const SET_SEARCH = 'SET_SEARCH';
export const SET_FILTER = 'SET_FILTER';
export const SET_SEARCH_ARRAY = 'SET_SEARCH_ARRAY';
export const SET_PREVIOUS_WINDOWS = 'SET_PREVIOUS_WINDOWS';
export const SET_INVENTORY_WINDOW = 'SET_INVENTORY_WINDOW';

export const SET_WARNING_READED = 'SET_WARNING_READED';
export const SET_ALERT_TAB = 'SET_ALERT_TAB';
export const SET_PROMINENT_TOOLBAR = 'SET_PROMINENT_TOOLBAR';

export const LOAD_ALERTS_SUCCESS = 'LOAD_ALERTS_SUCCESS';
export const ALERT_IS_LOADING = 'ALERT_IS_LOADING';
export const ALERT_IS_SAVING = 'ALERT_IS_SAVING';
export const ALERTS_DISMISS_SUCCESS = 'ALERTS_DISMISS_SUCCESS';
export const ALERTS_DELETE_SUCCESS = 'ALERTS_DELETE_SUCCESS';

export const SET_BLUETOOTH_USED = 'SET_BLUETOOTH_USED';

export const REPORT_SEARCH_IS_LOADING = 'REPORT_SEARCH_IS_LOADING';
export const REPORT_SEARCH_FIELDS_FETCH_DATA = 'REPORT_SEARCH_FIELDS_FETCH_DATA';
export const REPORT_SEARCH_VALUES_FETCH_DATA = 'REPORT_SEARCH_VALUES_FETCH_DATA';

export const REPORT_DECREASE_IS_LOADING = 'REPORT_DECREASE_IS_LOADING';
export const REPORT_DECREASE_VALUES_FETCH_DATA = 'REPORT_DECREASE_VALUES_FETCH_DATA';
export const REPORT_DECREASE_LOCALS_FETCH_DATA = 'REPORT_DECREASE_LOCALS_FETCH_DATA';

export const REPORT_LOT_IS_LOADING = 'REPORT_LOT_IS_LOADING';
export const REPORT_LOT_FETCH_DATA = 'REPORT_LOT_FETCH_DATA';

export const REPORT_APPCC_IS_LOADING = 'REPORT_APPCC_IS_LOADING';
export const REPORT_APPCC_FETCH_DATA = 'REPORT_APPCC_FETCH_DATA';

export const REPORT_EMPLOYEE_FETCH_DATA = 'REPORT_EMPLOYEE_FETCH_DATA';
export const REPORT_EMPLOYEE_IS_LOADING = 'REPORT_EMPLOYEE_IS_LOADING';

export const LOAD_INDICATORS_SUCCESS = 'LOAD_INDICATORS_SUCCESS';
export const DASHBOARDS_SUCCESS = 'DASHBOARDS_SUCCESS';
export const DASHBOARD_HAS_ERROR = 'DASHBOARD_HAS_ERROR';
export const INDICATORS_HAS_ERROR = 'INDICATORS_HAS_ERROR';
export const DASHBOARDS_IS_LOADING = 'DASHBOARDS_IS_LOADING';
export const DASHBOARDS_IS_SAVING = 'DASHBOARDS_IS_SAVING';
export const DASHBOARDS_CURRENT_TAB = 'DASHBOARDS_CURRENT_TAB';

export const LOAD_COMMUNICATION_SUCCESS = 'LOAD_COMMUNICATION_SUCCESS';
export const COMMUNICATIONS_SUCCESS = 'COMMUNICATIONS_SUCCESS';
export const COMMUNICATIONS_HAS_ERROR = 'COMMUNICATIONS_HAS_ERROR';
export const COMMUNICATIONS_IS_LOADING = 'COMMUNICATIONS_IS_LOADING';
export const COMMUNICATIONS_IS_SAVING = 'COMMUNICATIONS_IS_SAVING';
export const SET_FILTER_COMMUNICATION_SUCCESS = 'SET_FILTER_COMMUNICATION_SUCCESS';
export const PENDING_COMMUNICATION_SUCCESS = 'PENDING_COMMUNICATION_SUCCESS';
export const COMMUNICATIONS_EVT_COM_DELE = 'COMMUNICATIONS_EVT_COM_DELE';
export const COMMUNICATIONS_EVT_COM_ADD = 'COMMUNICATIONS_EVT_COM_ADD';
export const COMMUNICATIONS_EVT_COMMT_ADD = 'COMMUNICATIONS_EVT_COMMT_ADD';

export const LOAD_MESSAGE_SUCCESS = 'LOAD_MESSAGE_SUCCESS';
export const MESSAGES_SUCCESS = 'MESSAGES_SUCCESS';
export const MESSAGES_HAS_ERROR = 'MESSAGES_HAS_ERROR';
export const MESSAGES_IS_LOADING = 'MESSAGES_IS_LOADING';
export const MESSAGES_IS_SAVING = 'MESSAGES_IS_SAVING';
export const MESSAGE_MARK_AS_READED = 'MESSAGE_MARK_AS_READED';
export const MESSAGES_EVT_COM_ADD = 'MESSAGES_EVT_COM_ADD';
export const MESSAGES_EVT_CMNT_ADD = 'MESSAGES_EVT_CMNT_ADD';

export const LOAD_VISIBILITY_SUCCESS = 'LOAD_VISIBILITY_SUCCESS';
export const VISIBILITY_HAS_ERROR = 'VISIBILITY_HAS_ERROR';
export const VISIBILITY_IS_LOADING = 'VISIBILITY_IS_LOADING';

export const STS_IS_LOADING = 'STS_IS_LOADING';
export const STS_HAS_ERROR = 'STS_HAS_ERROR';
export const LOAD_STS_SUCCESS = 'LOAD_STS_SUCCESS';

export const REPORT_STS_IS_LOADING = 'REPORT_STS_IS_LOADING';
export const REPORT_STS_FETCH_DATA = 'REPORT_STS_FETCH_DATA';

export const LOAD_EMPLOYEE_SUCCESS = 'LOAD_EMPLOYEE_SUCCESS';
export const EMPLOYEES_SUCCESS = 'EMPLOYEES_SUCCESS';
export const EMPLOYEES_HAS_ERROR = 'EMPLOYEES_HAS_ERROR';
export const EMPLOYEES_IS_LOADING = 'EMPLOYEES_IS_LOADING';
export const EMPLOYEES_IS_SAVING = 'EMPLOYEES_IS_SAVING';

export const LOAD_ROLE_SUCCESS = 'LOAD_ROLE_SUCCESS';
export const ROLES_SUCCESS = 'ROLES_SUCCESS';
export const ROLES_HAS_ERROR = 'ROLES_HAS_ERROR';
export const ROLES_IS_LOADING = 'ROLES_IS_LOADING';
export const LOAD_APP_ROLES_SUCCESS = 'LOAD_APP_ROLES_SUCCESS';

export const LOAD_ONBOARDING_SUCCESS = 'LOAD_ONBOARDING_SUCCESS';
export const ONBOARDING_HAS_ERROR = 'ONBOARDING_HAS_ERROR';
export const ONBOARDING_IS_LOADING = 'ONBOARDING_IS_LOADING';
export const ONBOARDING_PERMISSIONS_SUCCESS = 'ONBOARDING_PERMISSIONS_SUCCESS';



// WEBPACK FOOTER //
// ./src/const/action.types.js